/**
 * @file store/dictStore.tsx
 * @description 字典数据缓存：避免重复请求的轻量状态容器。
 */
import { getDict } from '@/controllers/API/common'
import { create } from 'zustand'

/**
 * 后端返回的通用字典信息，以支持：
 * 1、/dict_detail/options： category(类型)，icon(图标)
 */

type DictType = {
  id: number | string
  value: string
  label: string
  create_time?: string
  dictionary_code?: string
  sort?: number
  states?: boolean
  update_time?: string
}

type BackendDictState = {
  category: DictType[]
  icon: DictType[]
}

type Actions = {
  /**
   * 懒加载字典选项并缓存
   * @param type 字典类型：'category' | 'icon' | 自定义
   * @returns 字典数组
   */
  loadDictOptions: (type: 'category' | 'icon' | string) => Promise<DictType[]>
}

export const useDictStore = create<BackendDictState & Actions>(set => ({
  category: [],
  icon: [],
  loadDictOptions: type => {
    if (useDictStore.getState()[type] && useDictStore.getState()[type].length) {
      return Promise.resolve(useDictStore.getState()[type].slice())
    }
    return getDict(type).then(res => {
      console.log('load backend dict: ', type)
      set({
        [type]: res ? res.slice() : []
      })
      return res || []
    })
  }
}))
